import { z } from 'zod';

export const contractSchema = z.object({
    resource_id: z.string(),
    resource_type: z.string(),
    paid: z.boolean(),
});
export type Contract = z.infer<typeof contractSchema>;

export const contractsResponseSchema = z.object({
    contracts: z.array(contractSchema),
});
export type Contracts = z.infer<typeof contractsResponseSchema>;
